import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-team-type',
  templateUrl: './team-type.component.html',
  styles: [
  ]
})
export class TeamTypeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
